module.exports = __webpack_public_path__ + "awkward.b4ab490a.png";